"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var ColorLookup_1 = __importDefault(require("../../utils/ColorLookup"));
var StyledIcon_1 = __importDefault(require("../StyledIcon/StyledIcon"));
/**
 * The Icon component creates an `<i/>` tag that references Honeywell’s official icon font sets.
 */
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genNewIcon = function () {
            var _a = _this.props, fitted = _a.fitted, root = _a.root, exactSize = _a.exactSize, padded = _a.padded, flipped = _a.flipped, loading = _a.loading, size = _a.size, cleanedProps = __rest(_a, ["fitted", "root", "exactSize", "padded", "flipped", "loading", "size"]);
            var convertedSize;
            if (exactSize) {
                if (typeof exactSize === 'number') {
                    convertedSize = exactSize + "px";
                }
                else {
                    convertedSize = exactSize;
                }
            }
            var newSize = exactSize ? convertedSize : size;
            return React.createElement(StyledIcon_1.default, __assign({}, cleanedProps, { size: newSize }));
        };
        return _this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, rotated = _a.rotated, loading = _a.loading, fitted = _a.fitted, flipped = _a.flipped, size = _a.size, className = _a.className, root = _a.root, description = _a.description, exactSize = _a.exactSize, color = _a.color, name = _a.name, padded = _a.padded, cleanedProps = __rest(_a, ["rotated", "loading", "fitted", "flipped", "size", "className", "root", "description", "exactSize", "color", "name", "padded"]);
        if (root === 'common') {
            return this.genNewIcon();
        }
        else {
            return (React.createElement("i", __assign({}, cleanedProps, { className: this.genIconClass(), style: this.genIconStyle(), title: this.props.description || '', "aria-label": this.props.description || '' })));
        }
    };
    Icon.prototype.genIconClass = function () {
        var _a = this.props, root = _a.root, name = _a.name, className = _a.className, flipped = _a.flipped, rotated = _a.rotated, fitted = _a.fitted, loading = _a.loading, size = _a.size;
        if (!root ||
            ['global', 'aero', 'building', 'weather', 'icon'].indexOf(root) === -1) {
            root = 'global';
        }
        var classstring = "h-icon " + root + " " + name;
        if (className) {
            classstring += ' ' + className;
        }
        if (flipped &&
            ['horizontally', 'vertically'].indexOf(flipped) !== -1) {
            classstring += " " + flipped + "-flipped";
        }
        if (fitted || rotated) {
            classstring += ' fitted';
        }
        if (loading) {
            classstring += ' loading';
        }
        if (size &&
            ['small', 'medium', 'large', 'xlarge'].indexOf(size) !== -1) {
            classstring += " scuf-" + size;
        }
        return classstring;
    };
    Icon.prototype.genIconStyle = function () {
        var style = {};
        var _a = this.props, color = _a.color, rotated = _a.rotated, exactSize = _a.exactSize;
        if (color) {
            style.color = ColorLookup_1.default(color);
        }
        if (rotated) {
            style.transform = "rotate(" + rotated + "deg)";
        }
        if (exactSize) {
            if (typeof exactSize === 'number') {
                style.fontSize = exactSize + "px";
            }
            else {
                style.fontSize = exactSize;
            }
        }
        return style;
    };
    Icon.defaultProps = {
        root: 'global'
    };
    return Icon;
}(react_1.Component));
exports.default = Icon;
